'use client';

import { EllipsisVerticalIcon } from '@heroicons/react/24/solid';

import { useTranslations } from '@northladder/i18n';

import {
  DropdownTw,
  DropdownItemTw,
  DropdownMenuTw,
  DropdownButtonTw,
} from '../ui';

export function MoreOptionsDropdown() {
  const t = useTranslations('BidsList.header');

  const handleOnSelectFilter = () => {};

  return (
    <DropdownTw>
      {/* @ts-ignore */}
      <DropdownButtonTw aria-label="More options" className="mx-2" plain="true">
        <EllipsisVerticalIcon />
      </DropdownButtonTw>
      <DropdownMenuTw>
        <DropdownItemTw disabled onClick={handleOnSelectFilter}>
          {t('actionExport')}
        </DropdownItemTw>
        <DropdownItemTw disabled onClick={handleOnSelectFilter}>
          {t('actionShare')}
        </DropdownItemTw>
        <DropdownItemTw disabled href="/articles/help/bidding">
          {t('actionSupport')}
        </DropdownItemTw>
      </DropdownMenuTw>
    </DropdownTw>
  );
}
